var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutEarly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.053,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20863",
    transform: "translate(22666.404 4906.5)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6570",
    fill: "none",
    stroke: "#869dad",
    d: "M-22664.676-4891h9.574"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 3508",
    cx: 5.998,
    cy: 5.98,
    rx: 5.998,
    ry: 5.98,
    transform: "translate(-22665.848 -4904.63)",
    fill: "#fff",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6578",
    fill: "none",
    stroke: "#f24040",
    d: "M-22659.852-4902.417v3.642"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12054",
    d: "M-22658.369-4901.388a3.066 3.066 0 0 1 1.313 3.353 2.938 2.938 0 0 1-5.658.218 3.075 3.075 0 0 1 1.063-3.445",
    fill: "none",
    stroke: "#f24040"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12055",
    d: "M-22665.065-4901.558a2.122 2.122 0 1 1 3.165-2.692",
    fill: "none",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12056",
    d: "M-22657.913-4904.29a2.122 2.122 0 1 1 3.27 2.6",
    fill: "none",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6579",
    fill: "none",
    stroke: "#869dad",
    d: "M-22661.748-4906h3.642"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutEarly);
export default __webpack_public_path__ + "static/media/Logout_early.fe68f5cb4f377b6bbc01c0238e370700.svg";
export { ForwardRef as ReactComponent };